import React, { PureComponent } from "react";
import classNames from "classnames";
import styles from "./Day.scss";
import parse from 'date-fns/parse';
import isAfter from 'date-fns/is_after';
import isBefore from 'date-fns/is_before';
import isEqual from 'date-fns/is_equal';
import _ from "lodash";
import checkDataAvailable from './../utils/checkDataAvailable';

export default class Day extends PureComponent {

    handleMouseEnter = () => {
        const { showTooltip } = this.props;
        const day = this.nodeRef.getBoundingClientRect();
        showTooltip && showTooltip({
            top: day.top,
            widthDay: day.width,
            left: day.left,
            date: this.props.date
        }, true);
    };

    handleMouseLeave = () => {
        const { showTooltip } = this.props;
        showTooltip && showTooltip({}, false);
    };

    handleClick = () => {
        let { date, isDisabled, onClick } = this.props;
        if (!isDisabled && _.isFunction(onClick)) {
            onClick(parse(date));
        }
    };

    refDay = (node) => {
        this.nodeRef = node;
    };

    renderSelection() {
        const {
            day,
            date,
            isToday,
            locale: { todayLabel },
            monthShort,
            theme: { textColor },
            selectionStyle
        } = this.props;

        return (
            <div
                className={styles.selection}
                data-date={date}
                style={{
                    backgroundColor: this.selectionColor,
                    color: textColor.active,
                    ...selectionStyle
                }}
            >
        <span className={styles.month}>
          {isToday ? todayLabel.short || todayLabel.long : monthShort}
        </span>
                <span className={styles.day}>{day}</span>
            </div>
        );
    }

    checkDataAvailable(data) {
        if (data.startDate === "N/A") {
            return false;
        }
        const startDate = parse(data.startDate);
        const endDate = parse(data.endDate);
        const currentDate = parse(this.props.date);
        return !!((isAfter(currentDate, startDate) || isEqual(currentDate, startDate)) && (isBefore(currentDate, endDate) || isEqual(currentDate, endDate)));
    }

    render() {
        const {
            className,
            currentYear,
            date,
            day,
            handlers,
            isDisabled,
            isHighlighted,
            isToday,
            isSelected,
            monthShort,
            theme: { selectionColor, todayColor },
            year,
            isShowDataCollected,
            adsTypeDate
        } = this.props;
        let color, noData;
        const {
            isSpotAvailable,
            isLiveReadAvailable,
            isWatchlistAvailable
        } = checkDataAvailable(date, adsTypeDate);
        const noDataCondition = isShowDataCollected && isSelected && !isSpotAvailable && !isLiveReadAvailable && !isWatchlistAvailable;

        if (noDataCondition) {
                noData = true;
                color = "#BDBDBD";
            }

        if (isSelected) {
            color = this.selectionColor = _.isFunction(selectionColor)
                ? selectionColor(date)
                : selectionColor;
        } else if (isToday) {
            color = todayColor;
        }
        
        return (
            <li
                style={color ? { color } : null}
                ref={this.refDay}
                className={classNames(styles.root, {
                    [styles.today]: isToday,
                    [styles.highlighted]: isHighlighted,
                    [styles.selected]: isSelected,
                    [styles.disabled]: isDisabled || noData,
                    [styles.enabled]: !isDisabled
                }, className, styles["day-container"])}
                onClick={this.handleClick}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
                data-date={date}
                {...handlers}
            >
                {day === 1 && <span className={styles.month}>{monthShort}</span>}
                {isToday ? <span>{day}</span> : day}
                {day === 1 && currentYear !== year &&
                    <span className={styles.year}>{year}</span>}
                {isSelected && this.renderSelection()}
                {isShowDataCollected &&
                    <div className={classNames(styles["day-bottom"])}>
                        {isSpotAvailable && <div className={classNames(styles.line, styles.spot)}/>}
                        {isLiveReadAvailable && <div className={classNames(styles.line, styles.liveRead)}/>}
                        {isWatchlistAvailable && <div className={classNames(styles.line, styles.watchlist)}/>}
                    </div>
                }
            </li>
        );
    }
}
